import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import AuthenticatedRoute from '../_app/auth/AuthenticatedRoute';
import { PaymentContainer } from '../Onboarding/Registration/onboarding/containers/Payment';
import ExpiredTokenContainer from '../Onboarding/Registration/onboarding/containers/ExpiredTokenContainer';
import { Error404Screen } from './errors';
import VerifyEmailContainer from '../Onboarding/Registration/onboarding/containers/UserRegistration/containers/VerifyEmailContainer';
import UserRegistrationQuery from '../Onboarding/Registration/onboarding/containers/UserRegistration/containers/UserRegistrationQuery';
import { SetupStaffPasswordContainer } from '../Onboarding/Setup/staff-password';
import OnboardingContainerWrapper from '../Onboarding/Registration/onboarding';
import { GoLivePage } from '../Onboarding/Setup/go-live';
import RFPThankYou from '../Onboarding/Registration/onboarding/containers/RFPThankYou';
import { LockedOnboarding } from '../Onboarding/Registration/onboarding/containers/LockedOnboarding';
import { SetupStaffTrainingContainer } from '../Onboarding/Setup/staff-training';
import TempEmailTokenVerification from '../Onboarding/Registration/onboarding/containers/TempEmailTokenVerification';
import SetupContainer from '../Onboarding/Setup';

const Router = () => (
  <Switch>
    <Route exact path="/" render={() => <Redirect to="/onboarding" />} />

    <AuthenticatedRoute
      exact
      path="/test-auth"
      component={() => <h1>User authenticated component prop</h1>}
      // render={() => <h1>User Authenticated render prop</h1>}
    />

    <Route exact path="/onboarding" component={OnboardingContainerWrapper} />
    <Route exact path="/onboarding/rfp" component={RFPThankYou} />
    <Route
      exact
      path="/onboarding/user-registration"
      component={UserRegistrationQuery}
    />
    <Route exact path="/onboarding/verify" component={VerifyEmailContainer} />
    <Route
      exact
      path="/verify/email/:token"
      component={TempEmailTokenVerification}
    />
    <Route exact path="/verify/expired" component={ExpiredTokenContainer} />
    <Route exact path="/onboarding/locked" component={LockedOnboarding} />
    <Route exact path="/onboarding/payment" component={PaymentContainer} />

    <AuthenticatedRoute path="/onboarding/setup" component={SetupContainer} />

    <AuthenticatedRoute
      exact
      path="/onboarding/go-live"
      component={GoLivePage}
    />

    <Route
      exact
      path="/staff-setup-password"
      component={SetupStaffPasswordContainer}
    />

    <Route exact path="/training" component={SetupStaffTrainingContainer} />
    <Route component={Error404Screen} />
  </Switch>
);

export default Router;



// WEBPACK FOOTER //
// ./src/_app/router.jsx